import { AuthentificationModule } from './authentification/authentification.module';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GuardsService } from './guards/guards.service';


const routes: Routes = [
  { path: 'pages', loadChildren: './authentification/authentification.module#AuthentificationModule'},
  { path: 'home', loadChildren: './home/home.module#HomeModule',canActivate: [GuardsService] },
  { path: '',
    redirectTo: '/pages/login',
    pathMatch: 'full'
  },
  { path: '**', redirectTo: localStorage.getItem('customer')==null?'/pages/login':'home' },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { 
}
